import axiosClient from "../../api/axiosClient";

export const allSchoolsFromServer = async () => {
  const response = await axiosClient.get("/schools");
  return response.data;
};

export const createSchoolFromServer = async (schoolId) => {
  const response = await axiosClient.post("/schools");
  return response.data;
};